<template>
  <div>
    <section
      v-if="isLoading"
      class="new-home-products-container-full-width-mobile"
    >
      <ul class="products-items-list">
        <ProductItemSkeleton
          v-for="(_, index) in Array.from({ length: skeletonNumbers })"
          :key="index"
        />
      </ul>
    </section>
    
    <InfiniteScroll
      v-if="!isLoading"
      :loadMore="loadMoreData"
      :isLoadingMore="isLoadingMore"
      :hasReachedEnd="hasReachedFullProductPages"
      :isLoading="isLoading"
      :endMessage="$t('general.no_more_products')"
      :enabled="enableAutoScroll"
    >
      <section
        id="sectionItemsList"
        class="flex flex-col gap-9"
      >
        <NewHomeSection
          :sortProductsBy="sortProductsBy"
          :itemsList="itemsList"
          :loadProductsSortedBy="loadProductsSortedBy"
          :isUpdatingProducts="isUpdatingProducts"
          :isInitiallyLoadingProducts="isInitiallyLoadingProducts"
          :filterProductsByType="filterProductsByType"
          :changeProductByTypeValue="changeProductByTypeValue"
          @saveProductCardPosition="handleSaveProductCardPosition"
          :portalPage="portalPage"
        />
      </section>
    </InfiniteScroll>

    <div
      v-if="showManualLoadButton"
      class="flex justify-center mt-6"
    >
      <button
        class="more__products--button text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-200 rounded-lg text-center font-medium min-w-[180px] px-8 py-3 disabled:opacity-60 disabled:cursor-not-allowed"
        :disabled="isLoadingMore"
        @click="handleManualLoadMore"
      >
        <span>
          {{
            isLoadingMore
              ? $t('general.loading')
              : $t('general.load_more')
          }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import NewHomeSection from "./NewHomeSection.vue";
import ProductItemSkeleton from "../productItemDesigns/ProductItemSkeleton.vue";
import InfiniteScroll from "../../common/InfiniteScroll.vue";

export default {
  name: "NewHomeSections",
  setup() {
    return {};
  },
  data() {
    return {
      section: {},
      skeletonNumbers: 10,
    };
  },
  components: {
    NewHomeSection,
    ProductItemSkeleton,
    InfiniteScroll,
  },
  props: {
    itemsList: {
      type: Array,
      required: true,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    loadMoreData: {
      type: Function,
      required: true,
    },
    isLoadingMore: {
      type: Boolean,
      required: true,
      default: false,
    },
    isUpdatingProducts: {
      type: Boolean,
      required: true,
      default: false,
    },
    isInitiallyLoadingProducts: {
      type: Boolean,
      required: true,
      default: false,
    },
    hasReachedFullPages: {
      type: Boolean,
      required: true,
      default: false,
    },
    sortProductsBy: {
      type: [String, Number],
      required: true,
      default: "all",
    },
    loadProductsSortedBy: {
      type: Function,
      required: true,
    },
    hasReachedFullProductPages:{
      type: Boolean,
      required: true,
      default: false,
    },
    filterProductsByType: {
      type: [Object, null],
      required: true,
      default: () => null,
    },
    changeProductByTypeValue: {
      type: Function,
      required: true
    },
    enableAutoScroll: {
      type: Boolean,
      required: true,
      default: true,
    },
    manualLoadMore: {
      type: Function,
      required: true,
    },
    portalPage: {
      type: String,
      required: false,
      default: null,
    },
  },
  
  methods: {
    // Handle product card position saving
    handleSaveProductCardPosition(productId) {
      console.log(`📍 NewHomeSections: Product card position event received for: ${productId}`);
      this.$emit('saveProductCardPosition', productId);
    },
    handleManualLoadMore() {
      if (typeof this.manualLoadMore === "function") {
        this.manualLoadMore();
      }
    }
  },
  computed: {
    showManualLoadButton() {
      return (
        !this.isLoading &&
        !this.hasReachedFullProductPages &&
        !this.enableAutoScroll
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
